import { render } from "./tdPart.vue?vue&type=template&id=19abe466&scoped=true"
import script from "./tdPart.vue?vue&type=script&lang=js"
export * from "./tdPart.vue?vue&type=script&lang=js"

import "./tdPart.vue?vue&type=style&index=0&id=19abe466&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19abe466"]])

export default __exports__